export default __webpack_public_path__ + "static/vibrationsarm-ohne-schalldaemmung_boge-minikompressoren-dce223ff27360446ed6ed5610adc20de.jpeg";